import store from '@/store';
import i18n from '@/i18n';

export default class VoiceUnpauseEvent {
  constructor(body) {
    const { status } = store.state.channel.channels.voice;
    const pauseName = body.body.reason;
    const channel = 'voice';
    const channelTranslate = i18n.t(channel);

    if (status == 'scheduled_pause')
      return store.dispatch('pause/revertStatusLeaveSchedulePause', {
        channel,
        channelName: 'Voz',
        pauseName,
      });

    store.dispatch('pause/unpauseVoiceChannel');
  }
}
